// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './RadioButton.scss';

import type { Node } from 'react';

type Color = 'lightBlue' | 'orange' | 'red';

type Props = {
  +handleChange: (e: SyntheticInputEvent<HTMLInputElement>) => void;
  +name: string;
  +value: string | boolean | number;
  +children?: Node;
  +selected: string | boolean | number;
  +color?: Color;
  +disabled?: boolean;
};

export const RadioButtonLoading = () => <div className={style.radioButtonLoadingWrap}/>; 

export default class RadioButton extends Component<Props, void> {
  static defaultProps = {
    color: 'lightBlue',
  };

  render() {
    const {
      handleChange, name, value, disabled,
      selected, children, color,
    } = this.props;
    // console.log(`\t${selected} === ${value}`, selected === value);
    return (<label className={classNames(style.radioButtonWrap, { [style.disabled]: disabled })}>
      <input type="radio"
             name={name}
             value={value}
             className={classNames({ [style.checked]: selected === value })}
             checked={selected === value}
             onChange={handleChange}/>

      <span className={classNames(style.checkmark, style[color])}/>
      <span className={classNames(style.content, style[color])}>{children}</span>
    </label>)
  }
}

RadioButton.propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.bool.isRequired,
    PropTypes.number.isRequired,
  ]),
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  children: PropTypes.node,
  color: PropTypes.string,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/RadioButton/RadioButton.jsx